import {
  Component,
  ViewChild,
  TemplateRef,
  AfterViewInit,
  ChangeDetectorRef,
  ElementRef,
  OnDestroy,
} from "@angular/core";
import { MatRowDef, MatTableModule } from "@angular/material/table";
import {
  MatDialogModule,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { CommonModule, NgIf } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import {
  MatPaginator,
  MatPaginatorIntl,
  MatPaginatorModule,
  PageEvent,
} from "@angular/material/paginator";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatSelectModule } from "@angular/material/select";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatOptionModule } from "@angular/material/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatSnackBar } from "@angular/material/snack-bar";
import UnitMeasurementsAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/masters/unit-measurements/unit-measurements.entity";
import { MatSidenavContainer } from "@angular/material/sidenav";
import { MatMenuModule } from "@angular/material/menu";
import { MatTabsModule } from "@angular/material/tabs";
import {
  MatTreeFlatDataSource,
  MatTreeFlattener,
  MatTreeModule,
} from "@angular/material/tree";
import { NgSelectModule } from "@ng-select/ng-select";
import { ICreateUnitOfMeasure } from "./interfaces/create-unit-measurement.interface";
import { UnitMeasureService } from "./unit-of-measurement.service";
import { IUpdateUnitOfMeasure } from "./interfaces/update-unit-measurement.interface";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { getCode } from "app/utils/method";
import { ExportService } from "app/layout/export-overlay/export-overlay.service";
import { ExportDialogComponent } from "app/layout/export-overlay/dialog/export-dialog.component";
import { ExportOptions } from "app/layout/export-overlay/tasks/core/export-task.interfaces";
import { UnitMeasurementExport } from "./exports/unit-of-measurement.export";
import { UNIT_OF_MEASUREMENT_TITLE } from "./exports/unit-of-measurement.constants";
import { Subscription } from "rxjs";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { StatusFiltersComponent } from "../../filters/status-filters/status-filters.component";
import { GroupUnitMeasureService } from "../../material/material-group-unit-measurement/material-group-unit-measurement.service";
import { IRequestResult } from "app/common/interfaces";
import { UnitMeasurementsGroupAttributes } from "@albatrosdeveloper/ave-models-package";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { FlatTreeControl } from "@angular/cdk/tree";

interface UnitNode extends UnitMeasurementsAttributes {
  children?: UnitNode[];
  auxUniqueGroup?: UnitMeasurementsGroupAttributes;
}
interface UnitFlatNode extends UnitMeasurementsAttributes {
  expandable: boolean;
  levelTree: number;
  auxUniqueGroup?: UnitMeasurementsGroupAttributes;
}
@Component({
  selector: "app-unit-of-measurement",
  templateUrl: "./unit-of-measurement.component.html",
  styleUrls: ["./unit-of-measurement.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenavContainer,
    FormsModule,
    NgSelectModule,
    MatTabsModule,
    NgxMatSelectSearchModule,
    StatusFiltersComponent,
    StatusFiltersComponent,
    HoverMenuDirective,
    MatTreeModule,
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    UnitMeasurementExport,
  ],
})
export class UnitOfMeasurementComponent implements AfterViewInit, OnDestroy {
  getCode = getCode;
  displayedColumns: string[] = ["name", "group", "status", "actions"];
  displayColumnsTree: string[] = ["group", "name", "status", "actions"];

  currentCreateUnitOfMeasure: ICreateUnitOfMeasure =
    this.initializeCreateUnitOfMeasure();
  currentUpdateUnitOfMeasure: IUpdateUnitOfMeasure | undefined;
  dataSource: UnitMeasurementsAttributes[] = [];
  modeTreeUnit: "group" | null = null;
  searchQuery: string = "";
  totalItems: number = 0;
  pageSize: number = 50;
  pageIndex: number = 1;
  sortActive: keyof UnitMeasurementsAttributes = "name";

  private transformer = (node: UnitNode, levelTree: number): UnitFlatNode => {
    return {
      ...node,
      expandable: !!node.children && node.children.length > 0,
      levelTree: levelTree,
    };
  };

  treeControl = new FlatTreeControl<UnitFlatNode>(
    (node) => node.levelTree,
    (node) => node.expandable
  );

  treeFlattener = new MatTreeFlattener(
    this.transformer,
    (node) => node.levelTree,
    (node) => node.expandable,
    (node) => node.children
  );
  dataSourceTree = new MatTreeFlatDataSource(
    this.treeControl,
    this.treeFlattener
  );
  hasChild = (_: number, node: UnitFlatNode) => node.expandable;

  //filter form
  groupUnitMeasurementList: UnitMeasurementsGroupAttributes[] = [];
  groupUnitMeasurementFilterList: UnitMeasurementsGroupAttributes[] = [];
  searchGroupUnit = "";

  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit: MatDialogRef<any>;

  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild("searchInput") searchInput!: ElementRef;

  //BUSCADOR
  searchSubscription: Subscription;
  selectedStatuses: [] = [];

  // Lazy loading flags
  private groupUnitsLoaded = false;

  constructor(
    private readonly unitService: UnitMeasureService,
    private readonly groupUnitMeasureService: GroupUnitMeasureService,
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    public exportService: ExportService,
    private unitMeasurementExport: UnitMeasurementExport
  ) { }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.setupPaginationAndSorting();
    this.findAllWithCount();
  }

  private buildTreeByGroup(data: UnitMeasurementsAttributes[]): UnitNode[] {
    const tempTree: UnitNode[] = [];
    const groupMap = new Map<string, UnitNode>();
    // Create parent nodes for each unique group
    for (const item of data ?? []) {
      if (item.group && !groupMap.has(item.group._id.toString())) {
        const groupNode: UnitNode = {
          ...item,
          _id: item.group._id,
          name: `${item.group.name} (${this.getCode(item.group) || "Sin código"})`,
          children: [],
          auxUniqueGroup: item.group,
        };
        groupMap.set(item.group._id.toString(), groupNode);
        tempTree.push(groupNode);
      }
    }
    for (const item of data ?? []) {
      if (item.group) {
        const groupNode = groupMap.get(item.group._id.toString());
        if (groupNode) {
          groupNode.children.push({
            ...item,
            auxUniqueGroup: item.group,
          });
        }
      }
    }
    return tempTree.sort((a, b) => a.name.localeCompare(b.name));
  }

  getGroupName(unit: any): string {
    if (this.modeTreeUnit === "group") {
      return unit.auxUniqueGroup?.name ?? "-";
    }
    return "-";
  }
  private getExpandedNodeIds(): string[] {
    return this.treeControl.expansionModel.selected.map((node) =>
      node._id.toString()
    );
  }

  private restoreExpandedNodes(expandedIds: string[]): void {
    this.treeControl.dataNodes.forEach((node) => {
      if (expandedIds.includes(node._id.toString())) {
        this.treeControl.expand(node);
      }
    });
  }

  private initializeCreateUnitOfMeasure(): ICreateUnitOfMeasure {
    return { name: "", code: "", hasacceptedDecimals: false, groupId: null };
  }

  private setupPaginationAndSorting(): void {
    this.paginator.page.subscribe(() => this.findAllWithCount());
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    });
  }

  findAllWithCount(): void {
    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" =
      this.sort.direction === "asc" ? "ASC" : "DESC";
    const expandedIds = this.getExpandedNodeIds();

    this.unitService
      .findAllWithCount(
        {
          currentPage: this.pageIndex,
          limitPerPage: this.pageSize,
          search: this.searchQuery,
          sort: sortField,
          sortDirection: sortDirection,
        },
        this.selectedStatuses,
        this.modeTreeUnit // Move tree mode handling to the service
      )
      .subscribe((data) => {
        this.dataSource = data?.data?.[0]?.data ?? [];
        this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        if (this.modeTreeUnit === "group") {
          this.dataSourceTree.data = this.buildTreeByGroup(this.dataSource);
          this.restoreExpandedNodes(expandedIds);
        }

        // Only display the paginator in normal mode
        if (!this.modeTreeUnit && this.paginator) {
          this.paginator.length = this.totalItems;
        }
      });
  }

  private getSortField(): keyof UnitMeasurementsAttributes {
    const sortFieldMapping: Record<string, keyof UnitMeasurementsAttributes> = {
      name: "name",
      group: <any>"group.externalKeys.code",
    };
    return sortFieldMapping[this.sortActive] || "name";
  }

  changeSort(e) {
    this.sortActive = e.active;
    this.findAllWithCount();
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex + 1;
    this.findAllWithCount();
  }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value.trim();
    if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
      // this.paginator.pageIndex = 0;
      this.findAllWithCount();
    }
  }

  public onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$.subscribe(
      (term) => {
        this.searchQuery = term;
        if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
          this.findAllWithCount();
        }
      }
    );
  }

  trackByFn(index: number, item: UnitMeasurementsAttributes): string {
    return item._id.toString();
  }

  openCreateModal(): void {
    this.ensureGroupUnitsLoaded();
    this.currentCreateUnitOfMeasure = this.initializeCreateUnitOfMeasure();
    this.dialogRefAdd = this.dialog.open(this.addModal, {
      panelClass: "form-modal",
      disableClose: true,
    });
    // this.dialogRefAdd.afterClosed().subscribe((result) => result && this.createUnitOfMeasure());
    this.dialogRefAdd.afterClosed().subscribe((result) => {
      result;
    });
  }

  openEditModal(unit: UnitMeasurementsAttributes): void {
    this.ensureGroupUnitsLoaded();
    this.currentUpdateUnitOfMeasure = {
      ...unit,
      groupId: unit.group?._id ? String(unit.group._id) : null,
    };
    this.dialogRefEdit = this.dialog.open(this.editModal, {
      panelClass: "form-modal",
      disableClose: true,
    });
    // this.dialogRefEdit.afterClosed().subscribe((result) => result && this.updateUnitOfMeasure(unit._id.toString()));
    this.dialogRefEdit.afterClosed().subscribe((result) => {
      result;
    });
  }

  createUnitOfMeasure(): void {
    this.unitService.create(this.currentCreateUnitOfMeasure).subscribe({
      next: () => {
        this.snackBar.open("Registro creado con éxito", "Cerrar", {
          duration: 3000,
        });
        this.findAllWithCount();
        this.dialogRefAdd.close();
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al crear el registro",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  updateUnitOfMeasure(id: string): void {
    if (this.currentUpdateUnitOfMeasure) {
      const updatedUnitOfMeasure: IUpdateUnitOfMeasure = {
        ...this.currentUpdateUnitOfMeasure,
        groupId: this.currentUpdateUnitOfMeasure.groupId,
      };

      this.unitService.update(id, updatedUnitOfMeasure).subscribe({
        next: () => {
          this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
          this.dialogRefEdit.close();
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
    }
  }

  // Función para manejar cambio de modo árbol
  onChangePointTree(element: "group" | null): void {
    this.modeTreeUnit = element;
    this.findAllWithCount();
  }
  onStatusChange(event: boolean, unit: UnitMeasurementsAttributes): void {
    const originalStatusId = unit.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedUnitOfMeasure = { ...unit, statusId: updatedStatusId };
    this.unitService
      .update(unit._id.toString(), updatedUnitOfMeasure)
      .subscribe({
        next: () => {
          this.findAllWithCount();
        },
        error: () => {
          unit.statusId = originalStatusId; // Volver al estado original si falla
          this.snackBar.open("Error al actualizar el estado.", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
        },
      });
  }

  openDeleteDialog(unit: UnitMeasurementsAttributes): void {
    this.dialog
      .open(this.deleteDialog, {
        data: unit,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => result && this.delete(unit._id.toString()));
  }

  delete(id: string): void {
    this.unitService.remove(id).subscribe(() => {
      this.findAllWithCount();
      this.snackBar.open("Registro eliminado con éxito", "Cerrar", {
        duration: 3000,
      });
    });
  }

  //filter
  getListGroupUnit() {
    this.groupUnitMeasureService.findToComboBox().subscribe({
      next: (res: IRequestResult<UnitMeasurementsGroupAttributes[]>) => {
        this.groupUnitMeasurementList = res.data;
        this.groupUnitMeasurementFilterList =
          this.groupUnitMeasurementList.slice();
        this.groupUnitsLoaded = true;
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al actualizar el registro",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  private ensureGroupUnitsLoaded(): void {
    if (!this.groupUnitsLoaded) {
      this.getListGroupUnit();
    }
  }

  changueOptionsGroupUnit(event) {
    if (!this.groupUnitMeasurementList) {
      return;
    }
    let search = event;
    if (!search) {
      this.groupUnitMeasurementFilterList =
        this.groupUnitMeasurementList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.groupUnitMeasurementFilterList = this.groupUnitMeasurementList.filter(
      (item) => item.name.toLowerCase().indexOf(search) > -1
    );
  }

  //exportar
  onExportButtonPressed() {
    if (!this.unitMeasurementExport.canStartTask()) return;
    const dialogRef = this.dialog.open(ExportDialogComponent, {
      data: { title: UNIT_OF_MEASUREMENT_TITLE },
    });
    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        this.unitMeasurementExport.export(
          options.format,
          options.range,
          this.totalItems,
          this.pageSize,
          this.pageIndex
        );
      }
    });
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
